const ACTIVE_STATUSES = new Set(['active', 'paused']);
const KNOWN_STATUSES = new Set(['active', 'paused', 'completed', 'closed', 'none']);

function normalizeId(value = '') {
  const normalized = String(value || '').trim();
  return normalized || null;
}

export function normalizeSessionStatus(status = '', missionSessionId = null) {
  const normalized = String(status || '').trim().toLowerCase();
  if (KNOWN_STATUSES.has(normalized)) return normalized;
  return missionSessionId ? 'active' : 'none';
}

export function buildContinuityContract({
  missionSessionId = null,
  activeMissionId = null,
  lastTurnId = null,
  hasActiveSession = null,
  sessionStatus = null
} = {}) {
  const resolvedSessionId = normalizeId(missionSessionId || activeMissionId);
  const normalizedStatus = normalizeSessionStatus(sessionStatus, resolvedSessionId);
  const inferredActive = Boolean(resolvedSessionId && ACTIVE_STATUSES.has(normalizedStatus));

  return {
    missionSessionId: resolvedSessionId,
    activeMissionId: resolvedSessionId,
    lastTurnId: normalizeId(lastTurnId),
    sessionStatus: normalizedStatus,
    hasActiveSession: typeof hasActiveSession === 'boolean'
      ? Boolean(resolvedSessionId && hasActiveSession)
      : inferredActive
  };
}

export function validateContinuityEnvelope(payload = {}, options = {}) {
  const source = payload && typeof payload === 'object' ? payload : {};
  const warnings = [];
  const errors = [];
  const allowMissingSession = options.allowMissingSession !== false;

  const envelope = buildContinuityContract({
    missionSessionId: source.missionSessionId,
    activeMissionId: source.activeMissionId,
    lastTurnId: source.lastTurnId,
    hasActiveSession: source.hasActiveSession,
    sessionStatus: source.sessionStatus
  });

  if (
    normalizeId(source.missionSessionId)
    && normalizeId(source.activeMissionId)
    && normalizeId(source.missionSessionId) !== normalizeId(source.activeMissionId)
  ) {
    warnings.push('missionSessionId and activeMissionId mismatch; missionSessionId wins');
  }

  if (envelope.lastTurnId && !envelope.missionSessionId) {
    warnings.push('lastTurnId provided without missionSessionId');
  }

  if (!allowMissingSession && envelope.hasActiveSession && !envelope.missionSessionId) {
    errors.push('missionSessionId required when hasActiveSession=true');
  }

  return {
    ok: errors.length === 0,
    errors,
    warnings,
    envelope
  };
}

export function applyContinuityEnvelope(payload = {}, envelope = {}) {
  const target = payload && typeof payload === 'object' ? payload : {};
  const normalized = buildContinuityContract(envelope);
  if (!normalized.missionSessionId && Object.prototype.hasOwnProperty.call(target, 'lastTurnId')) {
    delete target.lastTurnId;
  }
  if (normalized.missionSessionId && !target.missionSessionId) {
    target.missionSessionId = normalized.missionSessionId;
  }
  if (normalized.activeMissionId && !target.activeMissionId) {
    target.activeMissionId = normalized.activeMissionId;
  }
  if (normalized.lastTurnId && !target.lastTurnId) {
    target.lastTurnId = normalized.lastTurnId;
  }
  if (normalized.sessionStatus && target.sessionStatus == null) {
    target.sessionStatus = normalized.sessionStatus;
  }
  if (typeof normalized.hasActiveSession === 'boolean' && target.hasActiveSession == null) {
    target.hasActiveSession = normalized.hasActiveSession;
  }
  return target;
}
